import { render, staticRenderFns } from "./ContactTable.vue?vue&type=template&id=0533aca4&scoped=true"
import script from "./ContactTable.vue?vue&type=script&lang=js"
export * from "./ContactTable.vue?vue&type=script&lang=js"
import style0 from "./ContactTable.vue?vue&type=style&index=0&id=0533aca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533aca4",
  null
  
)

export default component.exports